<div class="bg-background flex min-h-screen flex-col items-center justify-center px-4">
  <div class="bg-card border-border max-w-md rounded-lg border p-8 text-center">
    <hlm-icon name="lucideLock" size="48" class="text-muted-foreground mx-auto mb-4" />
    <h1 class="font-display mb-2 text-2xl font-semibold">
      <!-- TODO i18n EB-3775 -->Access denied
    </h1>
    @if (variant() === 'no-role') {
      <p class="text-muted-foreground">
        <!-- TODO i18n EB-3775 -->You do not have permission to access AMIE. Please contact your administrator if you believe this is an error.
      </p>
    } @else {
      <p class="text-muted-foreground mb-4">
        <!-- TODO i18n EB-3775 -->We could not verify your access right now. The authentication service did not respond. Please try again later.
      </p>
      <button type="button" hlmBtn variant="outline" (click)="retry()">
        <!-- TODO i18n EB-3775 -->Retry
      </button>
    }
  </div>
</div>
